import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  standalone: false,
  selector: 'app-post-login',
  templateUrl: './post-login.component.html',
  styleUrls: ['./post-login.component.scss']
})
export class PostLoginComponent implements OnInit {

  constructor(private router: Router, private msalService: MsalService) { }

  ngOnInit(): void {
    // This is the MSAL redirectUri. Let MSAL finish processing the auth response here
    // before navigating -- navigating first leaves the interaction flag set, which makes
    // the next interactive call fail with BrowserAuthError: interaction_in_progress.
    this.msalService.handleRedirectObservable().subscribe({
      next: result => {
        if (result?.account) {
          this.msalService.instance.setActiveAccount(result.account);
        }
        this.router.navigate(['/home']);
      },
      error: err => {
        console.error('Error handling login redirect', err);
        this.router.navigate(['/home']);
      }
    });
  }

}
